import GiftVouchers from './gift-vouchers';

export default GiftVouchers;
